import React, { forwardRef } from 'react';
import { cnpjMask } from '@/utils/masks';

interface CnpjTextFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CnpjTextField = forwardRef<HTMLInputElement, CnpjTextFieldProps>(
  (props, ref) => {
    const { onChange, value, ...other } = props;
    return (
      <input
        {...other}
        ref={ref}
        value={cnpjMask(String(value ?? ''))}
        type="text"
        maxLength={18}
        onChange={event => {
          event.target.value = cnpjMask(event.target.value);
          onChange?.(event);
        }}
      />
    );
  }
);

CnpjTextField.displayName = 'CnpjTextField';

export default CnpjTextField;
